import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';

const tourSiteAPI = createApi({
    reducerPath: "tourSiteAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllTourSites: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `sites/get-all?page=${page}&size=${size}`;

                if (key) {
                    apiUrl += `&searchKey=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["tour_site"],
        }),
        getTourSiteByID: builder.mutation({
            query: ({id}) => ({
                url: `sites/get/by-id/${id}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
        createTourSite: builder.mutation({
            query: ({ body }) => ({
                url: `sites/create`,
                method: "POST",
                body
            }),
            invalidatesTags: ["tour_site"]
        }),
        updateTourSite: builder.mutation({
            query: ({ body }) => {
                const apiUrl = `sites/update`;

                return {
                    url: apiUrl,
                    method: "PUT",
                    body
                };
            },
            transformResponse: (response) => response,
            invalidatesTags: ["tour_site"]
        }),
        deleteTourSite: builder.mutation({
            query: ({id}) => ({
                url: `sites/delete/${id}`,
                method: "DELETE",
                body: {}
            }),
            invalidatesTags: ["tour_site"],
        })
    })
});

export const { 
    useGetAllTourSitesMutation,
    useGetTourSiteByIDMutation,
    useCreateTourSiteMutation,
    useUpdateTourSiteMutation,
    useDeleteTourSiteMutation
} = tourSiteAPI;

export default tourSiteAPI;